module.exports = __webpack_public_path__ + "static/media/main_small_2.836f7000.png";